import React from 'react';

import styles from '../FormGenerator.module.css';
import Markdown from 'markdown-to-jsx';
import TriStateSwitch from '../../../TriStateSwitch/TriStateSwitch';

const TRISTATE_LABELS = {
  left:   { title: 'Ja',   value: 'ja'     },
  center: { title: '-',    value: 'center' },
  right:  { title: 'Nein', value: 'nein'   },
};

const valueToPosition = { ja: 'left', nein: 'right', center: 'center' };
//import styles from './FormField.module.css';

const option2Label = opt => (!!opt.length ? opt : opt.label);
const option2value = opt => (!!opt.length ? opt : opt.value);
const option2class = opt => (!!opt.length ? ''  : opt.className);
const option2id    = opt => (!!opt.length ? opt : opt.label+opt.value);
const removeSpace  = str => (str.replace(/\s+/g, ''));

const FormField = (props) => {
  let inputElement = null;
  const containerClasses = [styles.InputContainer];
  //const labelClasses = [];
  //const inputClasses = [styles.Input];
  const inputElementClasses = [styles.InputElement];

  let validationError = null;
  if (props.invalid && props.shouldValidate) {
    if ( !props.value && props.shouldValidate?.required ) {
      inputElementClasses.push(styles.Required);
      validationError = <p className={styles.MissingError}>{props.absentValueMessage || 'Please enter a value'}</p>;
    } else {
      if  ( props.touched ) {      
        inputElementClasses.push(styles.Invalid);
        validationError = <p className={styles.ValidationError}>{props.errorMessage || 'Please enter a valid value'}</p>;
      }
    }
  }
  let element = null;
  let p = props.tag || 'input'

  if (props.name.match(/^X/)) {
    if (props.name.match(/^Xlinebreak/i)) p = 'linebreak';
    if (props.name.match(/^Xsmallskip/i)) p = 'smallskip';
    if (props.name.match(/^Xmedskip/i)) p = 'medskip';
    if (props.name.match(/^Xbigskip/i)) p = 'bigskip';
    if (props.name.match(/^Xmarkdown/i)) p = 'markdown';
    if (props.name.match(/^Xmarkup/i)) p = 'markdown';
    if (props.name.match(/^Xtext/i)) p = 'text';
    if (props.name.match(/^Xhrule/i)) p = 'hrule';
  }

  if (props.className) {
    props.className.split(' ').forEach( cl => {
      inputElementClasses.push(styles[cl]);
    });
  }

  if (props.containerClasses) {
    props.containerClasses.split(' ').forEach( cl => {
      containerClasses.push(styles[cl]);
    });
  }

  switch (p) {
    /*
            case ( 'input' ):
                inputElement = <input className={styles.InputElement} {...props} />;
                break;
    */
    case ('input'):
      inputElement = <input
        className={inputElementClasses.join(' ')}
        id={`input_${props.name}`}
        {...props.attributes}
        value={props.value}
        onChange={props.onChange} />;
      break;
    case ('textarea'):
      inputElement = <textarea
        className={inputElementClasses.join(' ')}
        id={`input_${props.name}`}
        {...props.attributes}
        value={props.value}
        onChange={props.onChange} />;
      break;
    case ('select'):
      inputElement = (
        <select
          className={inputElementClasses.join(' ')}
          id={`input_${props.name}`}
          value={props.value}
          onChange={props.onChange}>
          {props.selectOptions.map(option => (
            <option key={option.value ?? option} value={option.value ?? option}>
              {option.displayValue ?? option}
            </option>
          ))}
        </select>
      );
      break;
    case ('boxes'):
      inputElementClasses.shift(); // remove InputElement
      inputElementClasses.unshift(styles.CheckBoxFrame);

      const isSwitch = props.attributes.type === 'switch';
      const isRadio = props.attributes.type === 'radio';

      let buttons = props.attributes.options.map(option => {
        let checked = null;
        if (isSwitch) {
          checked = { checked: props.value === option2value( props.attributes.options[0] ) };
        } else if (isRadio) {
          checked = { checked: props.value === option2value( option ) };
        }

        const inputId = (isSwitch || props.attributes.type === 'checkbox')
          ? props.name
          : removeSpace(props.name + option2id( option ));
        const inputName = isRadio ? props.name : props.name + '[]';

        return (
          <div key={ removeSpace( option2id(option)) }
               id={ `container_${inputId}` }
               className={inputElementClasses.join(' ')}>
            <input
              id={inputId}
              type={isSwitch ? 'checkbox' : props.attributes.type}
              name={inputName}
              value={option2value( option )}
              onChange={props.onChange}
              {...option.attributes}
              {...checked}
            />
            <label htmlFor={inputId} className={styles[option2class( option )]}>{option2Label( option )}</label><br />
          </div>
        );
      })

      inputElement = (
        <div>
          {buttons}
        </div>
      )
      break;
    case ('tristate'):
      element = (
        <div className={styles.TristateRow}>
          <TriStateSwitch
            id={props.name}
            initialPosition={valueToPosition[props.value] || 'center'}
            labels={TRISTATE_LABELS}
            onChange={(value) => props.onChange({ target: { value } })}
          />
          <label>{props.label}</label>
        </div>
      );
      break;
    case ('hidden'):
      element = <input type="hidden" name={props.name} value={props.value} />;
      break
    case ('linebreak'):
      element = <div className={styles.Break}></div>
      break;
    case ('smallskip'):
      element = <div className={styles.SmallSkip}></div>
      break;
    case ('medskip'):
      element = <div className={styles.MedSkip}></div>
      break;
    case ('bigskip'):
      element = <div className={styles.BigSkip}></div>
      break;
    case ('markdown'):
      element = <div className={styles.Text}><Markdown>{props.value}</Markdown></div>
      break;
    case ('text'):
      element = <div className={styles.Text}>{props.value}</div>
      break;
    case ('hrule'):
      element = <div className={styles.Hrule}></div>;
      break;
    default:
      inputElement = <input
        className={inputElementClasses.join(' ')}
        {...props.attributes}
        value={props.value}
        onChange={props.onChange} />;
  }

  if (!element) {
    element = <div className={containerClasses.join(' ')}>
                { props.label
                  &&  <div className={styles.Label}>
                        <label id={`label_${props.name}`}>{props.label}</label>
                      </div>
                }
                <div className={styles.Input}>
                  {inputElement}
                  {validationError}
                </div>
              </div>
  }

  if (props.attributes?.type === 'hidden') {
    element = null;
  }

  return <>{element}</>;

}

export default FormField;